import { render, staticRenderFns } from "./userquestion.vue?vue&type=template&id=72f3e11a&scoped=true"
import script from "./userquestion.vue?vue&type=script&lang=js"
export * from "./userquestion.vue?vue&type=script&lang=js"
import style0 from "./userquestion.vue?vue&type=style&index=0&id=72f3e11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3e11a",
  null
  
)

export default component.exports